module.exports = __webpack_public_path__ + "img/9_103.d3092258.png";